import { render, staticRenderFns } from "./ResultGoods.vue?vue&type=template&id=80ec11f2&scoped=true&"
import script from "./ResultGoods.vue?vue&type=script&lang=js&"
export * from "./ResultGoods.vue?vue&type=script&lang=js&"
import style0 from "./ResultGoods.vue?vue&type=style&index=0&id=80ec11f2&scoped=true&lang=css&"
import style1 from "./ResultGoods.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ec11f2",
  null
  
)

export default component.exports